import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ConnectionService } from '../../../services/connection-service';

@Injectable()
export class RegimenResolve {
  constructor(private conn: ConnectionService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    return this.conn.getRegimen(route.params.id)
      .then((regimenObj: any): any => {
        if (regimenObj) return Promise.resolve(regimenObj);
        this.router.navigate(['/products/regimens']);
        return false;
      });
  }
}
